import { useState } from "react";
import type { Database } from "@/integrations/supabase/types";

type Media = Database['public']['Tables']['medias']['Row'] & {
  display_time: number;
  selected_screens: string[];
  user_id: string;
  created_at: string;
  updated_at: string;
  last_updated_at: string;
  active: boolean;
};

type Screen = Database['public']['Tables']['screens']['Row'];

/**
 * Hook centralizando os estados do Dashboard relacionados a modais e seleção.
 * Não contém nenhuma lógica de negócio.
 */
export function useDashboardState() {
  const [showCreateMediaModal, setShowCreateMediaModal] = useState(false);
  const [showCreateScreenModal, setShowCreateScreenModal] = useState(false);
  const [showEditMediaModal, setShowEditMediaModal] = useState(false);
  const [showEditScreenModal, setShowEditScreenModal] = useState(false);
  const [showDeviceActivationModal, setShowDeviceActivationModal] = useState(false);

  const [selectedMedia, setSelectedMedia] = useState<Media | null>(null);
  const [selectedScreen, setSelectedScreen] = useState<Screen | null>(null);

  const [isActivatingDevice, setIsActivatingDevice] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showCreativesModal, setShowCreativesModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);
  const [showRequiredInfoModal, setShowRequiredInfoModal] = useState(false);

  const [showMyPlanModal, setShowMyPlanModal] = useState(false);
  const [showPaymentHistoryModal, setShowPaymentHistoryModal] = useState(false);
  const [showVenuePartnerModal, setShowVenuePartnerModal] = useState(false);
  const [showNoActiveDevicesModal, setShowNoActiveDevicesModal] = useState(false);
  const [showPlayerScheduleModal, setShowPlayerScheduleModal] = useState(false);

  return {
    showCreateMediaModal,
    setShowCreateMediaModal,
    showCreateScreenModal,
    setShowCreateScreenModal,
    showEditMediaModal,
    setShowEditMediaModal,
    showEditScreenModal,
    setShowEditScreenModal,
    showDeviceActivationModal,
    setShowDeviceActivationModal,
    selectedMedia,
    setSelectedMedia,
    selectedScreen,
    setSelectedScreen,
    isActivatingDevice,
    setIsActivatingDevice,
    isDrawerOpen,
    setIsDrawerOpen,
    showCreativesModal,
    setShowCreativesModal,
    showChangePasswordModal,
    setShowChangePasswordModal,
    showProfileModal,
    setShowProfileModal,
    showPrivacyPolicyModal,
    setShowPrivacyPolicyModal,
    showRequiredInfoModal,
    setShowRequiredInfoModal,
    showMyPlanModal,
    setShowMyPlanModal,
    showPaymentHistoryModal,
    setShowPaymentHistoryModal,
    showVenuePartnerModal,
    setShowVenuePartnerModal,
    showNoActiveDevicesModal,
    setShowNoActiveDevicesModal,
    showPlayerScheduleModal,
    setShowPlayerScheduleModal,
  };
}
